import { Hero } from "@/components/home/Hero";
import { Showcase } from "@/components/home/Showcase";
import { ProductRail } from "@/components/home/ProductRail";
import { BrandMarquee, CollectionGrid, EverydayIcons, ExclusiveDrops, JordanCulture, NikeEssentials } from "@/components/home/Editorial";
import { useStore } from "@/context/StoreContext";
import { useSeo } from "@/lib/seo";

export default function Home() {
  const { t } = useStore();
  useSeo({
    title: null,
    description: "CASABLANCA — premium sneakers and streetwear. Nike, Air Jordan, Adidas, New Balance, Puma and Asics. Shipping across Europe.",
    jsonLd: { "@context": "https://schema.org", "@type": "Store", name: "CASABLANCA", url: window.location.origin, currenciesAccepted: "EUR", areaServed: "Europe" },
  });
  return (
    <main data-testid="home-page">
      <Hero />
      <BrandMarquee />
      <ProductRail id="new-arrivals" eyebrow="Chapter 01" title={t("newArrivals")} params={{ is_new: true, sort: "newest" }} to="/shop?is_new=1" />
      <CollectionGrid />
      <JordanCulture />
      <Showcase />
      <NikeEssentials />
      <ProductRail id="best-sellers" eyebrow="Most wanted" title={t("bestSellers")} params={{ bestseller: true, sort: "bestsellers" }} to="/shop?bestseller=1&sort=bestsellers" dark />
      <ExclusiveDrops />
      <EverydayIcons />
    </main>
  );
}
